<template lang="pug">
  div
    el-card
      div(slot="header")
        span.bold.s20 KPI
      div
        el-date-picker(v-model="week" type="week" format="yyyy 第 WW 周" :picker-options="{firstDayOfWeek:6}" placeholder="选择周" @change="changeWeek()")
      hr

      el-table.cl-table(v-for="type,tk in types" :key="tk" :data="tableData[type]" border style="width: 100%;")
        template(v-for="v,k in tableHead[type]")
          el-table-column(v-if="v.length>0" :label="k" :key="k" align="center")
            template(v-if="k=='周过程量' || k=='周结果量'")
              template(v-for="vv,kk in v")
                el-table-column(:label="vv" align="center")
                  el-table-column(:prop="vv+'_w'" label="完成" align="center")
                    template(slot-scope="scope")
                      span(:style="styleObject(scope.row[vv+'_w'],scope.row[vv+'_m'])") {{ scope.row[vv+'_w'] }}
                  el-table-column(:prop="vv+'_m'" label="目标" align="center")
            template(v-else)
              el-table-column(v-for="vv,kk in v" :prop="vv" :label="vv" :key="kk" align="center")
          el-table-column(v-else :label="k" :prop="k" align="center")
</template>

<script>
// Generated by CoffeeScript 2.3.0
let dateFormat, m

dateFormat = require('dateformat')

export default (m = {
  data: function() {
    return {
      week: new Date(new Date() - 7 * 24 * 60 * 60 * 1000),
      dayNum: 0,
      users: {},
      leader: [],
      leader2: [],
      normal: [],
      teams: {},
      types: ['R', '全能', '前端', '后端'],
      tableData: {
        R: [],
        全能: [],
        前端: [],
        后端: [],
      },
      tableHead: {
        R: {
          职级: [],
          姓名: [],
          团队业绩: ['业绩', '完成', '全年完成率', '当期达成率'],
          周过程量: ['电话', '推荐', '面试', '变动'],
          周结果量: ['offer', '到岗', 'BD-Leads', 'LIST'],
          本月: ['过程未完成累计', '过程完成率', '结果完成'],
        },
        全能: {
          类型: [],
          姓名: [],
          团队业绩: ['业绩', '完成', '全年完成率', '当期达成率'],
          周过程量: ['电话', '推荐', '面试', '变动'],
          周结果量: ['offer', '到岗', 'BD-Leads', 'LIST'],
          本月: ['过程未完成累计', '过程完成率', '结果完成'],
        },
        前端: {
          类型: [],
          姓名: [],
          团队业绩: ['业绩', '完成', '全年完成率', '当期达成率'],
          周过程量: ['电话', '会面', '线人', '变动'],
          周结果量: ['BD-Leads', 'Mapping', '薪酬', 'LIST'],
          本月: ['过程未完成累计', '过程完成率', '结果完成'],
        },
        后端: {
          类型: [],
          姓名: [],
          团队业绩: ['业绩', '完成', '全年完成率', '当期达成率'],
          周过程量: ['电话', '推荐', '面试', '变动'],
          周结果量: ['offer', '到岗', 'BD-Leads', 'LIST'],
          本月: ['过程未完成累计', '过程完成率', '结果完成'],
        },
      },
    }
  },
  methods: {
    getDaysInMonth: function() {
      let d, getMonth, i, j, ref, sum, sum1, y
      d = new Date()
      y = dateFormat(d, 'yyyy')
      m = dateFormat(d, 'm')
      d = dateFormat(d, 'd')
      getMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
      sum1 = 0
      for (i = j = 0, ref = m - 2; ref >= 0 ? j <= ref : j >= ref; i = ref >= 0 ? ++j : --j) {
        sum1 += getMonth[i]
      }
      if ((y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0)) && m > 2) {
        sum = parseInt(sum1) + parseInt(d)(+1)
      } else {
        sum = parseInt(sum1) + parseInt(d)
      }
      return sum
    },
    getWeek: function(w) {
      let currentDate, millisecond, minusDay, monday, month, startStop, sunday, week
      startStop = new Array()
      currentDate = new Date(new Date(w.toLocaleDateString()).getTime())
      week = currentDate.getDay()
      month = currentDate.getDate()
      millisecond = 1000 * 60 * 60 * 24
      if (week === 0) {
        minusDay = 6
      } else {
        minusDay = week - 1
      }
      monday = new Date(currentDate.getTime() - minusDay * millisecond)
      sunday = new Date(monday.getTime() + 7 * millisecond - 1)
      startStop.push(monday.getTime() / 1000 - 2 * 3600 * 24)
      startStop.push(sunday.getTime() / 1000 - 2 * 3600 * 24)
      return startStop
    },
    styleObject: function(w, m) {
      if (w < m) {
        return {
          color: '#f00',
        }
      }
      return {}
    },
    loadData: function() {
      this.dayNum = this.getDaysInMonth()
      // console.log @dayNum
      // 获取猎头业务部用户
      return app.api
        .find({
          tableName: 'users',
          query: {
            部门: '猎头业务部',
          },
        })
        .then(users => {
          this.users = users
          // 分类为团队长 团队长2 队员
          users.forEach(user => {
            let member
            if (user['角色'] && user['角色'].includes('团队长')) {
              this.leader.push(user.account)
              // 计算团队长和队员关系
              member = user['队员'].split(';')
              return (this.teams[user.account] = member)
            } else if (user['角色'] && user['角色'].includes('团队长2')) {
              return this.leader2.push(user.account)
            } else {
              return this.normal.push(user.account)
            }
          })
          return this.loadKpi()
        })
    },
    loadKpi: function() {
      let l2n, ll2, w
      // 获取团队长2和队员KPI
      w = this.getWeek(new Date(this.week.getTime() + 7 * 24 * 60 * 60 * 1000))
      l2n = this.leader2.concat(this.normal)
      ll2 = this.leader.concat(this.leader2)
      // console.log(l2n)
      return app.api
        .find({
          tableName: 'kpis',
          query: {
            date: {
              $lt: w[1],
              $gt: w[0],
            },
            姓名: {
              $in: l2n,
            },
          },
        })
        .then(tmp => {
          let k, kpis, kpis_obj, ll2user, obj, tmpu, tmpuser, v, yejis
          // console.log tmp
          // 统计团队长2和队员KPI
          kpis_obj = {}
          tmp.map(item => {
            let name, type
            name = item['姓名']
            type = item.type
            if (kpis_obj[name] == null) {
              kpis_obj[name] = {}
            }
            kpis_obj[name]['姓名'] = name
            if (kpis_obj[name][type]) {
              return kpis_obj[name][type]++
            } else {
              return (kpis_obj[name][type] = 1)
            }
          })
          for (k in kpis_obj) {
            v = kpis_obj[k]
            tmpuser = this.users.filter(u => u.account === k)
            tmpu = tmpuser[0]
            obj = {
              姓名: v['姓名'],
              角色: tmpu['角色'],
              职级: tmpu['职级'],
              类型: tmpu['类型'],
              电话_w: v['电话'] || 0,
              电话_m: parseInt(tmpu['电话'] || 0) * 5,
              推荐_w: v['推荐'] || 0,
              推荐_m: parseInt(tmpu['推荐'] || 0),
              面试_w: v['面试'] || 0,
              面试_m: parseInt(tmpu['面试'] || 0),
              LIST_w: v.LIST || 0,
              LIST_m: (parseFloat(tmpu.LIST || 0) / 4).toFixed(1),
              offer_w: v.offer || 0,
              offer_m: (parseFloat(tmpu.offer || 0) / 4).toFixed(1),
              到岗_w: v['到岗'] || 0,
              到岗_m: (parseFloat(tmpu['到岗'] || 0) / 4).toFixed(1),
              变动_w: v['变动'] || 0,
              变动_m: parseInt(tmpu['变动'] || 0),
              'BD-Leads_w': v['BD-Leads'] || 0,
              'BD-Leads_m': parseInt(tmpu['BD-Leads'] || 0),
              会面_w: parseInt(tmpu['会面完成'] || 0),
              会面_m: parseInt(tmpu['会面'] || 0),
              线人_w: parseInt(tmpu['线人完成'] || 0),
              线人_m: parseInt(tmpu['线人'] || 0),
              Mapping_w: parseInt(tmpu['Mapping完成'] || 0),
              Mapping_m: parseInt(tmpu.Mapping || 0),
              薪酬_w: parseInt(tmpu['薪酬完成'] || 0),
              薪酬_m: parseInt(tmpu['薪酬'] || 0),
              过程未完成累计: tmpu['过程未完成累计'],
              过程完成率: tmpu['过程完成率'],
              结果完成: tmpu['结果完成'],
            }
            kpis_obj[k] = obj
          }
          // console.log kpis_obj
          ll2user = this.users.filter(u => ll2.includes(u.account))
          yejis = ll2user.map(llu => {
            let yj
            yj = {
              姓名: llu.account,
              角色: llu['角色'],
              职级: llu['职级'],
              类型: llu['类型'],
              业绩: llu['业绩目标'],
              完成: llu['业绩完成'],
              全年完成率: `${((parseInt(llu['业绩完成'] || 0) / parseInt(llu['业绩目标'] || 1)) * 100).toFixed(2)}%`,
              当期达成率: `${(
                (parseInt(llu['业绩完成'] || 0) / ((parseInt(llu['业绩目标'] || 1) * this.dayNum) / 365)) *
                100
              ).toFixed(2)}%`,
              过程未完成累计: llu['过程未完成累计'],
              过程完成率: llu['过程完成率'],
              结果完成: llu['结果完成'],
            }
            return yj
          })
          // 团队长和团队长2按业绩完成排序
          // yejis.sort (a, b) =>
          //   af = parseFloat(a['完成']) || 0
          //   bf = parseFloat(b['完成']) || 0
          //   if af > bf
          //     return -1
          //   else if af < bf
          //     return 1
          //   else
          //     return 0
          // 团队长2KPI加入业绩
          yejis = yejis.map((y, k) => {
            let ref
            // y['排序'] = k+1
            if (y['角色'] && y['角色'].includes('团队长2')) {
              ref = kpis_obj[y['姓名']]
              for (k in ref) {
                v = ref[k]
                y[k] = v
              }
            }
            return y
          })
          // 队员放在团队长后
          kpis = []
          yejis.forEach(y => {
            kpis.push(y)
            if (this.teams[y['姓名']]) {
              return this.teams[y['姓名']].forEach(ty => {
                if (kpis_obj[ty]) {
                  return kpis.push(kpis_obj[ty])
                }
              })
            }
          })
          // console.log kpis
          // 分组
          this.tableData.R = kpis.filter(kpi => kpi['职级'] === 'R')
          this.tableData['全能'] = kpis.filter(kpi => kpi['类型'] === '全能')
          this.tableData['前端'] = kpis.filter(kpi => kpi['类型'] === '前端')
          return (this.tableData['后端'] = kpis.filter(kpi => kpi['类型'] === '后端'))
        })
    },
    changeWeek: function() {
      return this.loadKpi()
    },
  },
  created: function() {
    return this.loadData()
  },
})
</script>
